import script from "./BackgroundContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackgroundContainer.vue?vue&type=script&setup=true&lang=ts"

import "./BackgroundContainer.vue?vue&type=style&index=0&id=1e8e2eaa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e8e2eaa"]])

export default __exports__